<template>
  <v-footer padless class="site-footer">
    <v-container>
      <v-row>
        <v-col cols="12" md="3">
          <v-img :src="require('@/assets/logo.png')" contain max-width="145" class="footer-logo" />
          <p>Personalizamos tus ideas y creamos productos que cuentan historias.</p>
          <div class="social-links">
            <v-btn icon dark small @click="openLink('https://www.instagram.com/')"><v-icon>mdi-instagram</v-icon></v-btn>
            <v-btn icon dark small @click="openLink('https://www.facebook.com/')"><v-icon>mdi-facebook</v-icon></v-btn>
            <v-btn icon dark small @click="openLink('https://www.tiktok.com/')"><v-icon>mdi-music-note</v-icon></v-btn>
          </div>
        </v-col>
        <v-col cols="6" sm="3" md="2">
          <h4>Productos</h4>
          <a @click="goCatalog">Tazas</a><a @click="goCatalog">Franelas</a><a @click="goCatalog">Gorras</a><a @click="goCatalog">Termos</a><a @click="goCatalog">Mouse pads</a><a @click="goCatalog">Llaveros</a>
        </v-col>
        <v-col cols="6" sm="3" md="2">
          <h4>Información</h4>
          <a @click="goHome">Quiénes somos</a><a @click="goHome">Cómo personalizar</a><a @click="goHome">Preguntas frecuentes</a><span>Políticas de envío</span><span>Políticas de devolución</span><span>Términos y condiciones</span>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <h4>Contacto</h4>
          <a href="https://wa.me/584146058924" target="_blank"><v-icon small color="white" class="mr-2">mdi-whatsapp</v-icon>+58 414 605 8924</a>
          <a href="mailto:ventas@aguilaprint.com"><v-icon small color="white" class="mr-2">mdi-email-outline</v-icon>ventas@aguilaprint.com</a>
          <span><v-icon small color="white" class="mr-2">mdi-map-marker-outline</v-icon>Envíos a toda Venezuela</span>
          <span><v-icon small color="white" class="mr-2">mdi-clock-outline</v-icon>Lun. a vie. 8:00 a. m. – 6:00 p. m.</span>
        </v-col>
        <v-col cols="12" md="2">
          <h4>Síguenos</h4>
          <div class="footer-gallery"><v-img v-for="(image,index) in images" :key="index" :src="image" aspect-ratio="1" cover /></div>
          <small>@aguilaprint.ve</small>
        </v-col>
      </v-row>
      <v-divider class="my-6" dark />
      <div class="footer-bottom"><span>© {{ new Date().getFullYear() }} Aguila Print. Todos los derechos reservados.</span><div><v-chip x-small light>Pago móvil</v-chip><v-chip x-small light>Transferencia</v-chip><v-chip x-small light>Zelle</v-chip></div></div>
    </v-container>
  </v-footer>
</template>
<script>
export default {
  name:"SiteFooter",
  data(){return{images:[require('@/assets/taza_mock.png'),require('@/assets/poleraparapersonalizada.png'),require('@/assets/llavero1.png')]};},
  methods:{
    goHome(){if(this.$route.path!=='/principal')this.$router.push('/principal');window.scrollTo({top:0,behavior:'smooth'});},
    goCatalog(){if(this.$route.path!=='/product')this.$router.push('/product');},
    openLink(url){window.open(url,'_blank');}
  }
};
</script>
<style scoped>
.site-footer{padding:54px 0 22px;background:linear-gradient(135deg,#25073d,#4e0877)!important;color:#fff}.footer-logo{filter:brightness(0) invert(1);margin-bottom:15px}.site-footer p{max-width:300px;color:rgba(255,255,255,.68);font-size:13px;line-height:1.7}.site-footer h4{margin-bottom:15px;font-size:13px;text-transform:uppercase;letter-spacing:.1em}.site-footer a,.site-footer span{display:block;margin:8px 0;color:rgba(255,255,255,.7);font-size:12px;text-decoration:none;cursor:pointer}.site-footer a:hover{color:#fff}.social-links{display:flex;gap:5px}.footer-gallery{display:grid;grid-template-columns:repeat(3,1fr);gap:4px;overflow:hidden;border-radius:10px}.site-footer small{display:block;margin-top:8px;color:rgba(255,255,255,.72)}.footer-bottom{display:flex;justify-content:space-between;align-items:center;gap:20px}.footer-bottom span{margin:0}.footer-bottom>div{display:flex;gap:6px}@media(max-width:700px){.footer-bottom{align-items:flex-start;flex-direction:column}}
</style>
